/* assets/plan_to_cart_ajax.js */
(function(){
  'use strict';

  /** ****************************************************************
   * PLAN_DEFS（↙ 実ハンドルをここに統一）
   * ① はじめて：#1 / No.9 / 洗濯槽クリーナー
   * ② プラス   ：#1詰替 / ZERO / #1トライアル
   * ③ 臭い対策 ：#2 / #2詰替 / ZERO / クリーナー×2
   ******************************************************************/
  const PLAN_DEFS = {
    start: [
      { type:'product', handle:'rinenna1',          qty:1 },
      { type:'product', handle:'no9conditioner',    qty:1 },
      { type:'product', handle:'tubcleaner',        qty:1 },
    ],
    plus: [
      { type:'product', handle:'rinenna1re1-nom',   qty:1 },
      { type:'product', handle:'rinennaprozero100', qty:1 },
      { type:'product', handle:'prinenna1',         qty:1 }, // #1トライアル
    ],
    odor: [
      { type:'product', handle:'rinenna2',          qty:1 },
      { type:'product', handle:'rinenna2re1-nom',   qty:1 },
      { type:'product', handle:'rinennaprozero100', qty:1 },
      { type:'product', handle:'tubcleaner',        qty:2 },
    ],
  };

  const BASE = ""; // 同一ドメイン(rinenna.jp)想定

  /* ========= Variant解決 ========= */
  async function getVariantIdFromProductHandle(handle){
    const res = await fetch(`${BASE}/products/${handle}.js`, {credentials:'include'});
    if(!res.ok) throw new Error('product load failed: '+handle);
    const data = await res.json();
    const v = (data.variants||[]).find(v=>v.available) || data.variants?.[0];
    if(!v) throw new Error('variant not found: '+handle);
    return v.id;
  }
  async function getVariantIdFromCollectionHandle(handle){
    const res = await fetch(`${BASE}/collections/${handle}/products.json?limit=50`, {credentials:'include'});
    if(!res.ok) throw new Error('collection load failed: '+handle);
    const data = await res.json();
    for (const p of (data.products||[])){
      const v = (p.variants||[]).find(v=>v.available) || p.variants?.[0];
      if(v) return v.id;
    }
    throw new Error('no available variant in collection: '+handle);
  }
  async function resolvePlanItems(planKey){
    const defs = _state.PLAN_DEFS[planKey];
    if(!defs) throw new Error('unknown plan: '+planKey);
    const tmp = [];
    for(const d of defs){
      const id = await (d.type==='product'
        ? getVariantIdFromProductHandle(d.handle)
        : getVariantIdFromCollectionHandle(d.handle));
      tmp.push({id, quantity: d.qty||1});
    }
    // 同一variantを合算
    const map = new Map();
    for(const l of tmp){ map.set(l.id, (map.get(l.id)||0) + l.quantity); }
    return Array.from(map, ([id, quantity]) => ({id, quantity}));
  }

  /* ========= カート操作（行統合・propertiesなし） ========= */
  const readCart = async () => fetch(`${BASE}/cart.js`, {credentials:'include'}).then(r=>r.json());
  const hasProps = (li) => li.properties && Object.keys(li.properties).length>0;

  async function changeLineQtyByKey(key, quantity){
    return fetch(`${BASE}/cart/change.js`,{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      credentials:'include',
      body: JSON.stringify({ id:key, quantity })
    });
  }
  async function addOrIncrement(variantId, addQty){
    const cart = await readCart();
    // 1) properties無しの既存行を最優先して加算
    let target = cart.items.find(li => li.variant_id===variantId && !hasProps(li));
    if(target){ await changeLineQtyByKey(target.key, target.quantity + addQty); return; }
    // 2) properties有りの既存行に加算（既にある場合）
    target = cart.items.find(li => li.variant_id===variantId);
    if(target){ await changeLineQtyByKey(target.key, target.quantity + addQty); return; }
    // 3) 新規追加（propertiesは付けない）
    await fetch(`${BASE}/cart/add.js`, {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      credentials:'include',
      body: JSON.stringify({ id: variantId, quantity: addQty })
    });
  }
  async function addPlanMerged(planKey, btn, logEl){
    try{
      if(btn){ btn.disabled=true; btn.textContent='カートに追加中…'; }
      if(logEl) logEl.textContent='商品情報を取得中…';
      const items = await resolvePlanItems(planKey);
      if(logEl) logEl.textContent='カートに反映中…';
      for(const it of items){ await addOrIncrement(it.id, it.quantity); }
      if(logEl) logEl.textContent='カートに追加しました。';
      openCartDrawerOrGoCart();
    }catch(e){
      console.error(e);
      if(logEl) logEl.textContent='追加に失敗しました。ハンドル/在庫をご確認ください。';
    }finally{
      if(btn){ btn.disabled=false; btn.textContent='このプランをカートに入れる'; }
    }
  }
  function openCartDrawerOrGoCart(){
    const sels=['[data-cart-drawer-toggle]','[aria-controls="CartDrawer"]','.js-drawer-open-cart','button[name="drawer-open"]','.cart-toggle'];
    for(const s of sels){ const t=document.querySelector(s); if(t){ t.click(); return; } }
    location.href = `${BASE}/cart`;
  }

  /* ========= 価格取得＆描画 ========= */
  const CURRENCY_DIV = 100;  // ★ ここを100に戻す：cents → 円
  const yen = cents => '¥' + Math.round(cents / CURRENCY_DIV).toLocaleString('ja-JP');

  async function priceOfProductHandle(handle){
    const r = await fetch(`/products/${handle}.js`, {credentials:'include'});
    if(!r.ok) throw new Error('product load failed: '+handle);
    const d = await r.json();
    const v = (d.variants||[]).find(v=>v.available) || d.variants?.[0];
    if(!v) throw new Error('variant not found: '+handle);
    return v.price; // cents
  }
  async function priceOfCollectionHandle(handle){
    const r = await fetch(`/collections/${handle}/products.json?limit=50`, {credentials:'include'});
    if(!r.ok) throw new Error('collection load failed: '+handle);
    const d = await r.json();
    for(const p of d.products||[]){
      const v = (p.variants||[]).find(v=>v.available) || p.variants?.[0];
      if(v) return v.price; // cents
    }
    throw new Error('variant not found in collection: '+handle);
  }
  async function resolvePlanPriceAndCount(defs){
    let count=0, subtotal=0;
    for(const it of defs){
      const price = it.type==='product'
        ? await priceOfProductHandle(it.handle)
        : await priceOfCollectionHandle(it.handle);
      const qty = it.qty||1;
      subtotal += price * qty;
      count += qty;
    }
    const rate = count>=5 ? 0.15 : (count>=3 ? 0.10 : 0);
    const discount = Math.round(subtotal * rate);
    const total = subtotal - discount;
    return { count, subtotal, discount, total };
  }
  function _sel(target){
    if(!target) return null;
    if(typeof target==='string'){
      if(target.startsWith('#') || target.startsWith('.') || target.includes(' '))
        return document.querySelector(target);
      return document.getElementById(target);
    }
    return target;
  }
  async function renderPlanPrice(planKey, totalTarget, discountTarget){
    try{
      const defs = _state.PLAN_DEFS[planKey]; if(!defs) return;
      const { subtotal, discount, total } = await resolvePlanPriceAndCount(defs);
      const totalEl = _sel(totalTarget);
      const discEl  = _sel(discountTarget);
      if(totalEl) totalEl.textContent = yen(total);
      if(discEl)  discEl.textContent  = yen(discount);
    }catch(e){ console.error('price render failed:', planKey, e); }
  }

  /* ========= 初期化 ========= */
  function initPlanButtons(root=document){
    root.querySelectorAll('[data-plan]').forEach(btn=>{
      const key = btn.getAttribute('data-plan');
      const logEl = root.getElementById('log-'+key);
      btn.addEventListener('click', (e)=>{ e.preventDefault(); addPlanMerged(key, btn, logEl); });
    });
  }

  /* ========= 公開API ========= */
  const _state = { PLAN_DEFS: JSON.parse(JSON.stringify(PLAN_DEFS)) };
  window.RinennaBulk = {
    getPlanDefs(){ return JSON.parse(JSON.stringify(_state.PLAN_DEFS)); },
    setPlanDefs(next){
      if(!next || typeof next!=='object') return;
      _state.PLAN_DEFS = JSON.parse(JSON.stringify(next));
    },
    initPlanButtons,
    renderPlanPrice,
    renderAllPrices(map){
      Object.keys(map||{}).forEach(k=>{
        const m = map[k]; if(!m) return;
        renderPlanPrice(k, m.total, m.discount);
      });
    },
    _debug:{ resolvePlanItems, addPlanMerged }
  };
})();
